/**
 * If you revise following configuration, you should compile less with Webpack again.
 */
module.exports = {
}